import { createBrowserClient } from "@supabase/ssr";
import type { Database } from "./types";

/**
 * Supabase client for use in Client Components (browser only).
 * Reads session from cookies managed by the SSR layer.
 *
 * Usage:
 *   const supabase = createClient();
 *   const { data } = await supabase.from("professionals").select("*");
 */
export function createClient() {
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
}
